export default __webpack_public_path__ + "static/media/DSC02550 Large.0c64a37f.jpg";